import { mapGetters } from 'vuex'

// TODO: Remove this global mixin and add it per component as needed...

export const brandIdMixin = {
  computed: {
    ...mapGetters(['activeBrandId'])
  }
}
